"use client";
import * as React from "react";

export function NavigationMenu({isRegisterPage}) {
  const menuItems = [
    // { label: "Nossos Planos", target: "nossos-planos", type: "scroll" },
    isRegisterPage
      ? { label: "Nossos Planos", url: "/", type: "link" } // muda aqui
      : { label: "Nossos Planos", target: "nossos-planos", type: "scroll" },
    { label: "Rede Credenciada", url: "https://nacaosaude.centraldeatendimento.me/rede", type: "link" },
    { label: "Meu Clube", url: "https://nacaosaude.clubeparcerias.com.br", type: "link" },
    { label: "Entre em Contato", url: "https://api.whatsapp.com/send/?phone=5511916235625&text=Oi%2C+estou+precisando+de+atendimento&type=phone_number&app_absent=0", type: "link" },
  ];

  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav className="d-none d-md-flex align-items-center" style={{ gap: "2rem" }}>
      {menuItems.map((item, index) =>
        item.type === "scroll" ? (
          <a
            key={index}
            href={`#${item.target}`}
            onClick={(e) => handleScroll(e, item.target)}
            className="text-decoration-none"
            style={{
              color: "#6b7280",
              fontSize: "16px",
              transition: "color 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#2AAE3F")}
            onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
          >
            {item.label}
          </a>
        ) : (
          <a
            key={index}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none"
            style={{
              color: "#6b7280",
              fontSize: "16px",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#2AAE3F")}
            onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
          >
            {item.label}
          </a>
        )
      )}
    </nav>
  );
}